<div *ngIf="gatekeepers" class="vis-wrapper cursor-default vis-web-position-relative">
  <vis-web-back-to-top-button></vis-web-back-to-top-button>
  <div class="vis-web-page-wrapper">
    <div *ngIf="totalHits" class="vis-row">
      <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12">
        <h1>
          <span id="imprestAccountSearchResult">{{totalHits}}  {{'imprest.searchresult' | translate}}</span>
        </h1>
      </div>
    </div>
    <div *ngIf="totalHits > 0" class="vis-row">
      <div class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 pt-3 pb-3">
        <div class="vis-web-flex-base">
          <vsci-icon
            class="vis-web-margin-right-10-px"
            [hasFlexParent]="true"
            icon="linear-icons-file-empty"
            configClasses="size0-75x fillAnthrazit"
          ></vsci-icon>
          <div>
            <a href="{{pdfLink}}" id="cmdLnkPrintDoctorList" target="_blank">
              {{'ImprestSearchResult.pdfFile' | translate}}</a>
          </div>
        </div>
      </div>

      <!-- Arztmodell-Liste, wenn ein Netzwerk ausgewählt ist -->
      <div *ngIf="pdfLink_network" class="vis-col-mobile-12 vis-col-tablet-12 vis-col-desktop-12 pt-3 pb-3">
        <div class="vis-web-flex-base">
          <vsci-icon  class="vis-web-margin-right-10-px"
            [hasFlexParent]="true"
            icon="linear-icons-file-empty"
            configClasses="size0-75x fillAnthrazit"></vsci-icon>
          <div>
            <a href="{{pdfLink_network}}" id="cmdLnkPrintNwtworkList" target="_blank">
              {{'ImprestSearchResult.pdfFile-network' | translate}}
            </a>
          </div>
        </div>
      </div>

    </div>

    <!-- Search RESULT Header Component START -->
    <div *ngIf="totalHits > 0">
        <div class="vis-web-imprest-header vis-row vis-web-margin-left-right-0">
          <div class="vis-col-mobile-12 vis-col-tablet-4 vis-col-desktop-4 doc-name vis-web-svg-icon-fill-violet-medium vis-web-flex-base vis-web-imprest-header-col"
               id="resultHeader-name" (click)="sort('name')">
            <div [class]="'vis-web-sortable-col' + getSortingClass('name') + getSortingCursorClass()">{{'txt.nameDoctor' | translate}}</div>
            <vsci-icon *ngIf="key =='name' && (totalHits > 1)"
                       [icon]="reverse?'sort-asc':'sort-desc'"
                       [hasFlexParent]="true"
                       configClasses="size0-5x">
            </vsci-icon>
            <vsci-icon *ngIf="key !='name' && (totalHits > 1)"
                       [icon]="'sort'"
                       [hasFlexParent]="true"
                       configClasses="size0-5x">
            </vsci-icon>
          </div>
          <div class="vis-col-mobile-12 vis-col-tablet-3 vis-col-desktop-3 vis-web-svg-icon-fill-violet-medium vis-web-flex-base vis-web-imprest-header-col"
               id="resultHeader-locality" (click)="sort('locality')">
            <div [class]="'vis-web-sortable-col' + getSortingClass('locality') + getSortingCursorClass()">{{'common.contact.address.plz' | translate}} {{'common.contact.address.city' | translate}}</div>
            <vsci-icon *ngIf="key =='locality' && (totalHits > 1)"
                       [hasFlexParent]="true"
                       [icon]="reverse?'sort-asc':'sort-desc'"
                       configClasses="size0-5x">
            </vsci-icon>
            <vsci-icon *ngIf="key !='locality' && (totalHits > 1)"
                       [icon]="'sort'"
                       [hasFlexParent]="true"
                       configClasses="size0-5x">
            </vsci-icon>
          </div>
          <div class="vis-col-mobile-12 vis-col-tablet-2 vis-col-desktop-2 vis-web-svg-icon-fill-violet-medium vis-web-flex-base vis-web-imprest-header-col"
               id="resultHeader-billerType" (click)="sort('billerType')">
            <div [class]="'vis-web-sortable-col' + getSortingClass('billerType') + getSortingCursorClass()">{{'imprestaccount.doctor.rsttype' | translate}}</div>
            <vsci-icon *ngIf="key =='billerType' && (totalHits > 1)"
                       [hasFlexParent]="true"
                       [icon]="reverse?'sort-asc':'sort-desc'"
                       configClasses="size0-5x">
            </vsci-icon>
            <vsci-icon *ngIf="key !='billerType' && (totalHits > 1)"
                       [icon]="'sort'"
                       [hasFlexParent]="true"
                       configClasses="size0-5x">
            </vsci-icon>
          </div>
          <div class="vis-col-mobile-12 vis-col-tablet-3 vis-col-desktop-3 vis-web-svg-icon-fill-violet-medium vis-web-flex-base vis-web-imprest-header-col"
               id="resultHeader-availability">
            <div [class]="">{{'imprestaccount.doctor.availability' | translate}}</div>
          </div>
        </div>

        <div data-infinite-scroll
             debounce
             [infiniteScrollDistance]="scrollDistance"
             [infiniteScrollUpDistance]="scrollUpDistance"
             [infiniteScrollThrottle]="throttle"
             (scrolled)="onScrollDown()">
          <app-search-result-entry [arzt]="arzt" [index]="index"
                                   [searchCriteria]="searchCriteria"
                                   *ngFor="let arzt of gatekeepers; let index = index;"></app-search-result-entry>
        </div>
    </div>
  </div>
</div>
